module.exports = __webpack_public_path__ + "images/f52820561aaedfd20d1ce2944aaeff37.png";